var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#2096D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 5.8125C9.5625 5.48047 9.73828 5.1875 10.0312 5.01172C10.3047 4.83594 10.6758 4.83594 10.9688 5.01172C11.2422 5.1875 11.4375 5.48047 11.4375 5.8125C11.4375 6.16406 11.2422 6.45703 10.9688 6.63281C10.6758 6.80859 10.3047 6.80859 10.0312 6.63281C9.73828 6.45703 9.5625 6.16406 9.5625 5.8125ZM8.625 8.625C8.625 8.29297 8.89844 8 9.25 8H10.5C10.832 8 11.125 8.29297 11.125 8.625V13H11.75C12.082 13 12.375 13.293 12.375 13.625C12.375 13.9766 12.082 14.25 11.75 14.25H9.25C8.89844 14.25 8.625 13.9766 8.625 13.625C8.625 13.293 8.89844 13 9.25 13H9.875V9.25H9.25C8.89844 9.25 8.625 8.97656 8.625 8.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.904c3ece816246ccb189162327a4481a.svg";
export { ForwardRef as ReactComponent };